import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { SpinVizIrCommand, SpinVizIrExecutionResult } from '@contracts/index';

export interface AiChatMessage {
  id: string;
  sender: 'user' | 'assistant' | 'system';
  text: string;
  timestamp: string;
  associatedCommand?: SpinVizIrCommand;
  executionResult?: SpinVizIrExecutionResult;
  policyViolation?: string;
}

export interface AiState {
  messages: AiChatMessage[];
  isGenerating: boolean;
  pendingCommand: SpinVizIrCommand | null;
  policyStatus: 'clean' | 'violation_detected';
  lastPolicyMessage: string | null;
}

const initialState: AiState = {
  messages: [
    {
      id: 'msg-welcome',
      sender: 'system',
      text: 'SPIN-VIZ-IR v1 Copilot active. Commands are strictly semantic and validated against scientific policy.',
      timestamp: new Date().toISOString()
    }
  ],
  isGenerating: false,
  pendingCommand: null,
  policyStatus: 'clean',
  lastPolicyMessage: null
};

export const aiSlice = createSlice({
  name: 'ai',
  initialState,
  reducers: {
    addMessage: (state, action: PayloadAction<AiChatMessage>) => {
      state.messages.push(action.payload);
    },
    setIsGenerating: (state, action: PayloadAction<boolean>) => {
      state.isGenerating = action.payload;
    },
    setPendingCommand: (state, action: PayloadAction<SpinVizIrCommand | null>) => {
      state.pendingCommand = action.payload;
    },
    setPolicyViolation: (state, action: PayloadAction<string>) => {
      state.policyStatus = 'violation_detected';
      state.lastPolicyMessage = action.payload;
    },
    clearPolicyViolation: (state) => {
      state.policyStatus = 'clean';
      state.lastPolicyMessage = null;
    }
  }
});

export const {
  addMessage,
  setIsGenerating,
  setPendingCommand,
  setPolicyViolation,
  clearPolicyViolation
} = aiSlice.actions;

export default aiSlice.reducer;
